/* DockedByDesign — Product page JS  v2026-09-18-a
   Wires up: gallery thumbs, qty stepper, multi-option variant picker, sticky buy bar.
   Vanilla, no deps. Initialized on DOMContentLoaded. */

(function () {
  'use strict';

  // Visible version marker so we can confirm cache-busts
  try { console.log('[dbd-pdp] script loaded v2026-09-18-a'); } catch (e) {}

  // Restore scroll after a tier switch (tier links are full navigations so
  // third-party widgets like Selleasy re-render). Anchor-based: we put the
  // tier picker back at the same viewport offset it had when clicked, and we
  // do it synchronously (before first paint) so there's no visible jump.
  try {
    var _ts = sessionStorage.getItem('dbd-tier-scroll');
    if (_ts) {
      sessionStorage.removeItem('dbd-tier-scroll');
      _ts = JSON.parse(_ts);
      if (_ts && Date.now() - _ts.t < 10000) {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        var _tierRestore = function () {
          var a = document.querySelector('[data-tier-anchor]') || document.getElementById('tier') || document.querySelector('.dbd-pdp-hero__tiers');
          if (a && typeof _ts.a === 'number') {
            window.scrollTo(0, Math.max(0, a.getBoundingClientRect().top + window.scrollY - _ts.a));
          } else {
            window.scrollTo(0, _ts.y || 0);
          }
        };
        if (document.querySelector('.dbd-pdp-hero__tiers')) _tierRestore();
        else document.addEventListener('DOMContentLoaded', _tierRestore);
      }
    }
  } catch (e) {}
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-tier-switch], [data-flagship-link]');
    if (!link) return;
    try {
      var a = document.querySelector('[data-tier-anchor]') || document.getElementById('tier') || document.querySelector('.dbd-pdp-hero__tiers');
      sessionStorage.setItem('dbd-tier-scroll', JSON.stringify({
        y: window.scrollY,
        a: a ? a.getBoundingClientRect().top : null,
        t: Date.now()
      }));
      // Remember picked options (MacBook model, color, ...) so the sibling
      // tier's page can pre-select the same values instead of its default.
      var opts = {};
      document.querySelectorAll('[data-option-picker]').forEach(function (picker) {
        var name = picker.getAttribute('data-option-name');
        if (!name || name === 'Tier') return;
        var input = picker.querySelector('[data-option-input]:checked, select[data-option-input]');
        if (input && input.value) opts[name] = input.value;
      });
      sessionStorage.setItem('dbd-tier-opts', JSON.stringify({ o: opts, t: Date.now() }));
    } catch (e2) {}
  }, true);

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  /* ── Gallery ─────────────────────────────────────────── */
  function initGallery() {
    var gallery = $('[data-gallery]');
    var wrap = $('[data-gallery-main-wrap]');
    if (!gallery || !wrap) return;

    function escAttr(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function renderMedia(t) {
      var type = t.getAttribute('data-media-type') || 'image';
      var src = t.getAttribute('data-src') || '';
      var alt = t.getAttribute('data-alt') || '';
      var poster = t.getAttribute('data-poster') || '';

      // Tag the wrap so CSS can drop the 1:1 aspect-ratio lock for video media
      wrap.setAttribute('data-media-type', type);

      // Build new media element with createElement (avoids innerHTML parsing
      // mangling Shopify CDN URLs that contain `&`).
      var newEl;
      if (type === 'video') {
        newEl = document.createElement('video');
        newEl.setAttribute('data-gallery-main', '');
        newEl.controls = true;
        newEl.playsInline = true;
        newEl.autoplay = true;
        newEl.preload = 'metadata';
        if (poster) newEl.poster = poster;
        var source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        newEl.appendChild(source);
        // Once metadata loads, lock the wrap's aspect-ratio to the video's natural ratio
        newEl.addEventListener('loadedmetadata', function () {
          if (newEl.videoWidth && newEl.videoHeight) {
            wrap.style.aspectRatio = newEl.videoWidth + ' / ' + newEl.videoHeight;
          }
        });
      } else if (type === 'external_video') {
        // Guard: if src is empty (Shopify hasn't populated embed_url and the
        // liquid fallback couldn't construct one either), show a clear message
        // instead of an iframe with src="" rendering as a gray YouTube frame.
        if (!src) {
          wrap.style.aspectRatio = '';
          newEl = document.createElement('div');
          newEl.className = 'dbd-pdp-hero__main-empty';
          newEl.textContent = 'Video still processing — refresh in a minute, or check the YouTube URL is public and embedding-enabled.';
          wrap.innerHTML = '';
          wrap.appendChild(newEl);
          try { console.warn('[dbd-pdp] external_video has empty src — embed_url not populated yet'); } catch (e) {}
          return;
        }
        newEl = document.createElement('iframe');
        var sep = src.indexOf('?') >= 0 ? '&' : '?';
        newEl.src = src + sep + 'autoplay=1';
        newEl.setAttribute('data-gallery-main', '');
        newEl.setAttribute('allowfullscreen', '');
        newEl.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        newEl.title = alt;
        newEl.frameBorder = '0';
      } else {
        // Reset any video-driven aspect-ratio when going back to an image
        wrap.style.aspectRatio = '';
        newEl = document.createElement('img');
        newEl.setAttribute('data-gallery-main', '');
        newEl.src = src;
        newEl.alt = alt;
        newEl.loading = 'eager';
      }

      // Replace existing media in the wrap
      wrap.innerHTML = '';
      wrap.appendChild(newEl);
    }

    function activate(t) {
      try { console.log('[dbd-pdp] thumb activated', t.getAttribute('data-media-type'), t.getAttribute('data-src')); } catch (e) {}
      $$('[data-gallery-thumb]').forEach(function (x) {
        x.classList.remove('is-active');
        x.setAttribute('aria-selected', 'false');
      });
      t.classList.add('is-active');
      t.setAttribute('aria-selected', 'true');
      // Keep the active thumb visible in the strip (no scrollIntoView — manual scroll)
      var strip = t.closest('.dbd-pdp-hero__thumbs');
      if (strip) {
        var horizontal = strip.scrollWidth > strip.clientWidth + 4;
        if (horizontal) {
          strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
        } else {
          strip.scrollTo({ top: t.offsetTop - (strip.clientHeight - t.offsetHeight) / 2, behavior: 'smooth' });
        }
      }
      renderMedia(t);
    }

    // Document-level delegation — works regardless of `display: contents` reflow,
    // mobile column-reverse, or any DOM rearrangement.
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-gallery-thumb]');
      if (!t) return;
      e.preventDefault();
      activate(t);
    });

    // Swipe on the main media (mobile) — horizontal swipe steps prev/next.
    // Passive listeners: vertical page scroll is untouched; we only act on a
    // clearly horizontal gesture. Skipped when the finger lands on a video or
    // iframe (those own their gestures).
    (function () {
      var sx = 0, sy = 0, tracking = false;
      wrap.addEventListener('touchstart', function (e) {
        tracking = false;
        if (e.touches.length !== 1) return;
        if (e.target.closest && e.target.closest('video, iframe')) return;
        tracking = true;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var p = e.changedTouches[0];
        var dx = p.clientX - sx, dy = p.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return; // scroll or tap, not a swipe
        var thumbs = $$('[data-gallery-thumb]');
        if (thumbs.length < 2) return;
        var idx = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (idx < 0) idx = 0;
        var next = idx + (dx < 0 ? 1 : -1);
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        activate(thumbs[next]);
      }, { passive: true });
    })();

    // Desktop drag-to-scroll on the thumbs strip — click+drag pans the column.
    var thumbsStrip = document.querySelector('.dbd-pdp-hero__thumbs');
    if (thumbsStrip) {
      var dragging = false, dragStartY = 0, dragStartX = 0, dragStartTop = 0, dragStartLeft = 0, dragMoved = false;
      thumbsStrip.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        dragging = true;
        dragMoved = false;
        dragStartY = e.clientY;
        dragStartX = e.clientX;
        dragStartTop = thumbsStrip.scrollTop;
        dragStartLeft = thumbsStrip.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dy = e.clientY - dragStartY;
        var dx = e.clientX - dragStartX;
        if (Math.abs(dy) > 5 || Math.abs(dx) > 5) {
          dragMoved = true;
          thumbsStrip.classList.add('is-dragging');
        }
        if (dragMoved) {
          thumbsStrip.scrollTop = dragStartTop - dy;
          thumbsStrip.scrollLeft = dragStartLeft - dx;
        }
      });
      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        thumbsStrip.classList.remove('is-dragging');
        // Reset dragMoved on next tick so the trailing click sees it true and is suppressed
        setTimeout(function () { dragMoved = false; }, 0);
      });
      // Suppress the click that follows a real drag (not a plain click)
      thumbsStrip.addEventListener('click', function (e) {
        if (dragMoved) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      }, true);
    }

    // iOS Safari fallback — click sometimes doesn't fire on buttons inside
    // overflow:auto scrollers. We watch touchstart/touchend and synthesize a tap
    // when the finger didn't move (i.e. it wasn't a scroll gesture).
    var touchStartX = 0, touchStartY = 0, touchTarget = null;
    document.addEventListener('touchstart', function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-gallery-thumb]');
      if (!t) { touchTarget = null; return; }
      touchTarget = t;
      var p = e.touches[0] || e.changedTouches[0];
      touchStartX = p.clientX; touchStartY = p.clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!touchTarget) return;
      var p = e.changedTouches[0];
      var dx = Math.abs(p.clientX - touchStartX);
      var dy = Math.abs(p.clientY - touchStartY);
      var t = touchTarget;
      touchTarget = null;
      if (dx > 8 || dy > 8) return; // it was a scroll, not a tap
      e.preventDefault();
      activate(t);
    }, { passive: false });
  }

  /* ── Qty stepper ─────────────────────────────────────── */
  function initQty() {
    var input = $('[data-qty-input]');
    if (!input) return;
    $$('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-qty-step'), 10) || 1;
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ── Multi-option variant picker ─────────────────────── */
  function initVariantPicker() {
    var data = $('[data-variants-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput     = $('[data-buy-id]');
    var priceEl     = $('[data-buy-price]');
    var compareEl   = $('[data-buy-compare]');
    var stockEl     = $('[data-buy-stock]');
    var submit      = $('[data-buy-submit]');
    var submitLabel = $('[data-buy-submit-label]');

    function currentSelection() {
      var sel = [];
      $$('[data-option-picker]').forEach(function (picker) {
        var idx = parseInt(picker.getAttribute('data-option-index'), 10);
        var input = picker.querySelector('[data-option-input]:checked, select[data-option-input]');
        if (input) sel[idx] = input.value;
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return sel[i] == null || sel[i] === val; });
      });
    }

    /* Annotate tier-card prices */
    $$('[data-option-price-for]').forEach(function (el) {
      var key = el.getAttribute('data-option-price-for').split('::');
      var idx = parseInt(key[0], 10), value = key[1];
      var match = variants.find(function (v) { return v.options[idx] === value; });
      if (match) el.textContent = match.price;
    });

    function applyVariant(v) {
      if (!v) return;
      /* highlight active option cards */
      $$('[data-option-picker]').forEach(function (picker) {
        var idx = parseInt(picker.getAttribute('data-option-index'), 10);
        $$('.dbd-pdp-hero__tier, .dbd-pdp-hero__chip', picker).forEach(function (el) {
          var input = el.querySelector('[data-option-input]');
          if (input && input.value === v.options[idx]) el.classList.add('is-active');
          else el.classList.remove('is-active');
        });
      });

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      var tierMeta = document.querySelector('[data-tier-this-price]');
      if (tierMeta) tierMeta.textContent = v.price;
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price !== v.price) {
          compareEl.textContent = v.compare_at_price;
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (stockEl) {
        stockEl.innerHTML = v.available
          ? '<span class="dbd-pdp-hero__stock-dot" aria-hidden="true"></span> In stock · ships in 48 h'
          : 'Out of stock';
      }
      if (submit) submit.disabled = !v.available;
      if (submitLabel) submitLabel.textContent = v.available ? 'Add to cart' : 'Out of stock';

      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = v.price;

      var cmp = $('[data-compare]');
      if (cmp && v.options[0]) cmp.setAttribute('data-active-tier', v.options[0]);

      // Announce the change so listeners (spec sheet per-variant rows, etc)
      // can react. The specs section listens for `dbd:variant`.
      document.dispatchEvent(new CustomEvent('dbd:variant', { detail: { id: v.id } }));
    }

    function onChange() {
      var v = findVariant(currentSelection());
      applyVariant(v);
    }

    $$('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', onChange);
    });

    /* Restore option choices saved on a tier switch (e.g. MacBook model)
       so switching Standard/Pro/Elite keeps the buyer's model instead of
       resetting to the first variant. Values are matched by option name,
       exact first, then normalized (case/punctuation-insensitive). */
    try {
      var savedRaw = sessionStorage.getItem('dbd-tier-opts');
      if (savedRaw) {
        sessionStorage.removeItem('dbd-tier-opts');
        var saved = JSON.parse(savedRaw);
        if (saved && saved.o && Date.now() - saved.t < 600000) {
          var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); };
          var prev = currentSelection();
          var touched = false;
          $$('[data-option-picker]').forEach(function (picker) {
            var name = picker.getAttribute('data-option-name');
            if (!name || saved.o[name] == null || name === 'Tier') return;
            var want = saved.o[name];
            var sel = picker.querySelector('select[data-option-input]');
            if (sel) {
              var optEl = Array.from(sel.options).find(function (o) { return o.value === want; })
                       || Array.from(sel.options).find(function (o) { return norm(o.value) === norm(want); });
              if (optEl && sel.value !== optEl.value) { sel.value = optEl.value; touched = true; }
              return;
            }
            var radios = $$('input[data-option-input]', picker);
            var hit = radios.find(function (r) { return r.value === want; })
                   || radios.find(function (r) { return norm(r.value) === norm(want); });
            if (hit && !hit.checked) { hit.checked = true; touched = true; }
          });
          // If the restored combination doesn't exist as a variant, undo.
          if (touched && !findVariant(currentSelection())) {
            $$('[data-option-picker]').forEach(function (picker) {
              var idx = parseInt(picker.getAttribute('data-option-index'), 10);
              var sel2 = picker.querySelector('select[data-option-input]');
              if (sel2) { sel2.value = prev[idx]; return; }
              $$('input[data-option-input]', picker).forEach(function (r) { r.checked = (r.value === prev[idx]); });
            });
          }
        }
      }
    } catch (eRestore) {}

    /* prime on load */
    onChange();
  }

  /* ── Sticky mobile buy ───────────────────────────────── */
  function initSticky() {
    var sticky = $('[data-pdp-sticky]');
    var hero = $('[data-pdp-hero]');
    if (!sticky || !hero) return;
    var stickyAtc = $('[data-sticky-atc]');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        var form = document.getElementById('dbd-pdp-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    }, { rootMargin: '-200px 0px 0px 0px', threshold: 0 });
    io.observe(hero);
  }

  /* ── Tier switch: real navigation ─────────────────────
     Was an AJAX content swap, but app-injected widgets (Selleasy etc)
     only render on a real page load and vanished after every swap.
     The click handler at the top saves scrollY; the restore block at
     the top of this file puts it back on the next load, so the switch
     still feels in-place. */
  function initTierAjax() { /* intentionally empty: links navigate normally */ }

  function init() {
    initGallery();
    initQty();
    initVariantPicker();
    initSticky();
    initTierAjax();
    initAjaxAddToCart();
  }

  /* ── AJAX add-to-cart → opens Dawn cart drawer ───────── */
  function initAjaxAddToCart() {
    var form = document.getElementById('dbd-pdp-form');
    if (!form || form.dataset.dbdBound) return;
    form.dataset.dbdBound = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-buy-submit]');
      var label = form.querySelector('[data-buy-submit-label]');
      var prevLabel = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      var formData = new FormData(form);
      var drawer = document.querySelector('cart-drawer');
      var bubble = document.getElementById('cart-icon-bubble');

      // Detect bundle/upsell hidden inputs (SellEasy etc) using Shopify's
      // standard `items[N][id]` / `items[N][quantity]` / `items[N][properties][...]`
      // syntax. /cart/add.js only accepts that as a JSON `items` array.
      var bundleItems = [];
      var mainQty = parseInt(formData.get('quantity'), 10) || 1;
      var mainId = formData.get('id');
      // Line item properties (custom crossbar fit etc). The plain FormData path
      // sends properties[...] inputs automatically; this JSON bundle path must
      // carry them explicitly or they get dropped.
      var mainProps = {};
      formData.forEach(function (value, key) {
        var pm = key.match(/^properties\[(.+)\]$/);
        if (pm && value) mainProps[pm[1]] = value;
      });
      if (mainId) {
        var mainItem = { id: mainId, quantity: mainQty };
        if (Object.keys(mainProps).length) mainItem.properties = mainProps;
        bundleItems.push(mainItem);
      }
      var sawBundleInput = false;
      formData.forEach(function (value, key) {
        var m = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (m) {
          sawBundleInput = true;
          var idx = parseInt(m[1], 10);
          while (bundleItems.length <= idx + 1) bundleItems.push({ id: 0, quantity: 1 });
          var slot = bundleItems[idx + 1];
          if (m[2] === 'id') slot.id = value;
          else slot.quantity = parseInt(value, 10) || 1;
        }
      });
      // Drop any rows we created that ended up without an id
      bundleItems = bundleItems.filter(function (it) { return it.id; });

      // SellEasy ("lb" widget): selected upsells are `<lb-upsell-flat-card lb-selected lb-variant-id="…">`
      // (no form inputs — they ship custom elements). Pick them up by attribute.
      var selleasyCards = document.querySelectorAll(
        'lb-upsell-flat-card.lb-selected[lb-variant-id], lb-upsell-flat-card[lb-selected][lb-variant-id]'
      );
      selleasyCards.forEach(function (card) {
        var vid = card.getAttribute('lb-variant-id');
        if (!vid) return;
        var qty = parseInt(card.getAttribute('lb-quantity'), 10) || 1;
        bundleItems.push({ id: vid, quantity: qty });
        sawBundleInput = true;
      });

      var addPromise;
      if (sawBundleInput) {
        addPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: bundleItems })
        });
      } else {
        addPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
      }

      addPromise
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (label) label.textContent = res.body && res.body.description ? 'Unavailable' : 'Try again';
            if (btn) btn.disabled = false;
            setTimeout(function () { if (label) label.textContent = prevLabel; if (btn) btn.disabled = false; }, 2000);
            return;
          }
          if (!drawer) { window.location.href = '/cart'; return; }
          // Re-fetch cart-drawer + bubble fresh from server (most reliable across Dawn versions)
          return fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              try {
                var html = sections['cart-drawer'];
                if (html) {
                  var doc = new DOMParser().parseFromString(html, 'text/html');
                  // Dawn wraps in a section div; find the cart-drawer custom element inside
                  var newDrawer = doc.querySelector('cart-drawer');
                  if (newDrawer) {
                    drawer.innerHTML = newDrawer.innerHTML;
                    drawer.classList.remove('is-empty');
                  }
                }
                if (bubble && sections['cart-icon-bubble']) {
                  var bDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                  bubble.innerHTML = bDoc.body.innerHTML;
                }
                // Open the drawer
                if (typeof drawer.open === 'function') drawer.open();
                else if (drawer.classList) {
                  drawer.classList.add('active', 'animate', 'is-open');
                  document.body.classList.add('overflow-hidden');
                }
              } catch (err) {
                window.location.href = '/cart';
                return;
              }
              if (label) label.textContent = 'Added ✓';
              setTimeout(function () { if (label) label.textContent = prevLabel; if (btn) btn.disabled = false; }, 1200);
            });
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  /* ── Empty-cart drawer: keep "Continue shopping" on the current page ──
     Dawn's empty cart-drawer renders a link to /collections/all. Override:
     close the drawer instead so the user stays on the PDP they're on. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('cart-drawer a, cart-drawer button[name="continue"]');
    if (!a) return;
    var href = (a.getAttribute('href') || '').trim();
    // Only intercept the empty-cart fallback links (collections/all, root, or empty)
    if (href === '' || href === '/' || /\/collections(\/all)?\/?$/.test(href)) {
      e.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.close === 'function') drawer.close();
        else {
          drawer.classList.remove('active', 'animate', 'is-open');
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
